var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStatusInactive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 1C5.92487 1 1 5.92487 1 12C1 18.0752 5.92487 23 12 23C18.0752 23 23 18.0752 23 12C23 5.92487 18.0752 1 12 1ZM3 12C3 7.02943 7.02943 3 12 3C16.9705 3 21 7.02943 21 12C21 16.9705 16.9705 21 12 21C7.02943 21 3 16.9705 3 12Z",
    fill: "#222222",
    stroke: "#222222",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3242 4.32195L14.132 8.45407L14.132 8.45408L14.1307 8.45537L14.1214 8.46456L14.1214 8.46459L8.46448 14.1214C8.46435 14.1216 8.46421 14.1217 8.46408 14.1218L4.76268 17.8232L4.58591 18L4.76266 18.1768L5.82321 19.2375L5.99999 19.4143L6.17678 19.2375L9.8787 15.5356L15.5355 9.87877L19.6765 5.73781L19.8481 5.56619L19.6816 5.38957L18.6816 4.32853L18.5063 4.14248L18.3242 4.32195Z",
    fill: "#222222",
    stroke: "#222222",
    strokeWidth: 0.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusInactive);
export default __webpack_public_path__ + "static/media/status-inactive.d1ad257d.svg";
export { ForwardRef as ReactComponent };